<template>

  <data-form
    model="users"
    :entity="currentUser"
    :fields="fields"
    :after-submit="afterSubmit"
    :cancel="false"
  />

</template>

<script>
export default {
  name: 'admin-modification',
  data () {
    return {
      fields: {
        'id': {
          type: 'hidden'
        },
        'email': {
          type: 'email',
          rules: [{ required: true }, { max: 254 }, { type: 'email' }]
        },
        'password': {
          type: 'password',
          rules: [{ required: true }, { max: 254 }]
        }
      }
    }
  },
  computed: {
    currentUser () {
      const currentUser = this.$store.getters.currentUser || {}

      return {
        id: currentUser.id,
        email: currentUser.email
      }
    }
  },
  methods: {
    afterSubmit () {
      this.$emit('next')
    }
  }
}
</script>


// WEBPACK FOOTER //
// AdminModification.vue?33115174